import { toast } from 'react-toastify';
import ModalConfirm, { useModalConfirmRef } from 'widgets/ModalConfirm';
import { getMessageError } from 'services/response';
import dashboardApis from '../apis';
import { setPageLoading } from 'widgets/PageLoading';
import useGetListScreens from './useGetListScreens';

export const useDeleteScreen = (
) => {
  const modalConfirmRef = useModalConfirmRef();
  const { screensParams, mutate } = useGetListScreens(true);

  const handleDelete = async (id: string, onSuccess?: () => void) => {
    try {
      setPageLoading(true);
      const res = await dashboardApis.deleteScreen(id);

      if (res?.data?.data) {
        toast.success('Screen deleted successfully');
        mutate({
          ...screensParams,
        });

        onSuccess && onSuccess();
      }
    } catch (error) {
      toast.error(getMessageError(error));
    } finally {
      setPageLoading(false);
    }
  };

  const onDelete = (id: string, onSuccess?: () => void) => {
    modalConfirmRef.current?.open(() => handleDelete(id, onSuccess), {
      message: 'Are you sure you want to delete this screen? This action cannot be undone.',
    });
  };

  const context = <ModalConfirm ref={modalConfirmRef} />;

  return {
    onDelete,
    context,
  };
};
